// MUI's baseCheckbox slot doesn't receive the row id or row data for the per-row checkbox
// (only tabIndex/checked/onChange/disabled/...), so a per-row tooltip has to resolve the row
// from the DOM via the closest ancestor grid row element (`[role="row"][data-id]`) instead.
export function resolveRowIdFromCheckboxNode(node: Element | null): string | undefined {
  return node?.closest('[data-id]')?.getAttribute('data-id') ?? undefined
}
